import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../../Theme';
import BoxRowItem from './BoxRowItem';
import { cleanProps } from '../../../utils/HelpFunctions';

const StyledBoxRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: ${({ gap }) => theme.space[gap] || theme.space.sm};
  width: 100%;
  margin: 0 auto;
  max-width: ${({ fullWidth }) => (fullWidth ? '100%' : theme.breakpoints.xl)};
  flex-direction: ${({ reverse }) => (reverse ? 'row-reverse' : 'row')};
  flex-wrap: wrap;

  ${theme.above.lg} {
    flex-wrap: nowrap;
  }
`;

const Padded = styled.div`
  padding: 0 16px;
  width: 100%;
`;

function BoxRow({ children, ...props }) {
  const clean = cleanProps(props);

  let { gap, fullWidth, reverse, doubleOnMobile } = clean;
  return (
    <Wrapper fullWidth={fullWidth}>
      <StyledBoxRow gap={gap} fullWidth={fullWidth} reverse={reverse}>
        {children.map(c => {
          return (
            <BoxRowItem
              key={c.key}
              type={c.props.backgroundColor ? 'BoxRowColor' : 'BoxRowItem'}
              {...c.props}
              rowAmount={c.length}
              doubleOnMobile={doubleOnMobile}
            />
          );
        })}
      </StyledBoxRow>
    </Wrapper>
  );
}

const Wrapper = ({ children, style, className, fullWidth }) => {
  return fullWidth ? (
    <div style={{ ...style, width: '100%' }}>{children}</div>
  ) : (
    <Padded style={{ ...style }}>{children}</Padded>
  );
};

export default BoxRow;
